import React from 'react';
import { motion } from 'motion/react';
import { BadgeCheck, ShieldCheck, Globe, Lock, Award } from 'lucide-react';
import { staggerContainer, staggerItem } from '../../lib/motion';
import { cn } from '../../lib/utils';

interface TrustItem {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const trustItems: TrustItem[] = [
  { icon: BadgeCheck, label: 'WhatsApp Business API ufficiale' },
  { icon: ShieldCheck, label: 'Conforme GDPR' },
  { icon: Globe, label: 'Dati ospitati in UE' },
  { icon: Lock, label: 'Crittografia SSL/TLS' },
  { icon: Award, label: 'Certificati ISO 27001' },
];

const TrustBand: React.FC = () => {
  return (
    <section className="py-8 lg:py-10 bg-background">
      <div className="container mx-auto px-4">
        <motion.ul
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
          className={cn(
            'flex flex-wrap items-center justify-center gap-x-6 gap-y-4 lg:gap-x-8',
            'rounded-2xl border border-border bg-muted/40 px-6 py-5 lg:px-8 lg:py-6 shadow-sm'
          )}
        >
          {trustItems.map((item) => (
            <motion.li
              key={item.label}
              variants={staggerItem}
              className="flex items-center gap-2.5"
            >
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-2xl bg-primary/10 shrink-0">
                <item.icon className="h-4 w-4 text-primary" aria-hidden="true" />
              </span>
              <span className="text-sm font-medium text-text-secondary">
                {item.label}
              </span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default TrustBand;
